import type { FaireProductEntity } from "../../entity_types/product";

export const p_6xjmkawq7n: FaireProductEntity = {
  token: "p_6xjmkawq7n",
  type: "product",
  name: "Blush Candle",
  brandToken: "b_rk82ea6pnc",
  brandName: "Smeli",
  imageUrl:
    "https://cdn.faire.com/fastly/8be4e43567f2aab7c080b2b1f26439fe2304fb90e9afc1f62d8e76e217a52847.png",
  galleryImageUrls: [],
  priceDollars: 14,
  description:
    "Blush is a 9 oz single wick candle in a black glass vessel, finished with our signature die cut illustrated label.\n\nJuicy peach and bright bergamot soften with a touch of sugar before melting into delicate rice milk and violet, then settling into creamy coconut, sandalwood, and sheer musk. Soft, sun warmed, and delicately sweet, Blush feels like ripe peaches hanging heavy from the branch on a warm afternoon, their skins flushed pink in the sun.\n\nRipe. Soft. Sun warmed.\n\nPeach | Bergamot | Rice Milk | Violet | Sandalwood | Musk\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:03.419Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
